(function () {
  function initVideos(root) {
    if (!root || root.dataset.erProductVideosReady === 'true') return;
    root.dataset.erProductVideosReady = 'true';

    root.querySelectorAll('[data-erv-video-poster]').forEach(function (poster) {
      poster.addEventListener('click', function () {
        var media = poster.closest('.erv-card__media');
        var player = media ? media.querySelector('[data-erv-video-player]') : null;
        if (!player) return;

        poster.hidden = true;
        player.hidden = false;

        var video = player.querySelector('video');
        if (video && typeof video.play === 'function') {
          video.play().catch(function () {});
        }

        var iframe = player.querySelector('iframe');
        if (iframe) {
          try {
            var source = new URL(iframe.src, window.location.href);
            source.searchParams.set('autoplay', '1');
            iframe.allow = (iframe.allow ? iframe.allow + '; ' : '') + 'autoplay';
            iframe.src = source.toString();
          } catch (error) {
            // Keep the video provider URL unchanged if it cannot be parsed.
          }
        }
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-er-product-videos]').forEach(initVideos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
